/**
 * Browser-native drop-in for Node's `querystring` module.
 * Only the `stringify` and `parse` methods are used by the SDK source.
 */
export const stringify = (obj: Record<string, unknown>): string =>
  new URLSearchParams(obj as Record<string, string>).toString();

export const parse = (str: string): Record<string, string> =>
  Object.fromEntries(new URLSearchParams(str));

export default { stringify, parse };
